var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5H13.0469C12.7344 1.09375 11.4844 0 10 0C8.47656 0 7.22656 1.09375 6.91406 2.5H5C3.59375 2.5 2.5 3.63281 2.5 5V17.5C2.5 18.9062 3.59375 20 5 20H15C16.3672 20 17.5 18.9062 17.5 17.5V5C17.5 3.63281 16.3672 2.5 15 2.5ZM10 1.875C10.5078 1.875 10.9375 2.30469 10.9375 2.8125C10.9375 3.35938 10.5078 3.75 10 3.75C9.45312 3.75 9.0625 3.35938 9.0625 2.8125C9.0625 2.30469 9.45312 1.875 10 1.875ZM15.625 17.5C15.625 17.8516 15.3125 18.125 15 18.125H5C4.64844 18.125 4.375 17.8516 4.375 17.5V5C4.375 4.6875 4.64844 4.375 5 4.375H5.70312C5.625 4.60938 5.625 4.80469 5.625 5V5.625C5.625 5.97656 5.89844 6.25 6.25 6.25H13.75C14.0625 6.25 14.375 5.97656 14.375 5.625V5C14.375 4.80469 14.3359 4.60938 14.2578 4.375H15C15.3125 4.375 15.625 4.6875 15.625 5V17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/PlanIcon.36b2f1429e6f3bbda2b5407a55e0d870.svg";
export { ForwardRef as ReactComponent };